module.exports = __webpack_public_path__ + "img/dada_logo.e9d73886.jpeg";